import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ClientAuthProvider } from "@/context/ClientAuthContext";
import PortalLogin from "@/pages/portal/PortalLogin";
import PortalActivate from "@/pages/portal/PortalActivate";
import PortalHome from "@/pages/portal/PortalHome";
import ClientInvoices from "@/pages/admin/ClientInvoices";
import ClientAccounts from "@/pages/admin/ClientAccounts";
import Support from "@/pages/admin/Support";

import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Solutions from "@/pages/public/Solutions";
import SolutionDetail from "@/pages/public/SolutionDetail";
import Services from "@/pages/public/Services";
import ServiceDetail from "@/pages/public/ServiceDetail";
import Products from "@/pages/public/Products";
import ProductDetail from "@/pages/public/ProductDetail";
import Blog from "@/pages/public/Blog";
import BlogPost from "@/pages/public/BlogPost";
import Contact from "@/pages/public/Contact";
import Devis from "@/pages/public/Devis";
import DynamicForm from "@/pages/public/DynamicForm";

import Login from "@/pages/admin/Login";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import CRM from "@/pages/admin/CRM";
import WhatsAppAdmin from "@/pages/admin/WhatsAppAdmin";
import SolutionsAdmin from "@/pages/admin/SolutionsAdmin";
import ServicesAdmin from "@/pages/admin/ServicesAdmin";
import ProductsAdmin from "@/pages/admin/ProductsAdmin";
import BlogAdmin from "@/pages/admin/BlogAdmin";
import Marketing from "@/pages/admin/Marketing";
import MediaAdmin from "@/pages/admin/MediaAdmin";
import PagesAdmin from "@/pages/admin/PagesAdmin";
import FormsAdmin from "@/pages/admin/FormsAdmin";
import Finance from "@/pages/admin/Finance";
import Users from "@/pages/admin/Users";
import Activity from "@/pages/admin/Activity";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <AuthProvider>
    <ClientAuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/:slug" element={<SolutionDetail />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/produits" element={<Products />} />
            <Route path="/produits/:slug" element={<ProductDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/devis" element={<Devis />} />
            <Route path="/formulaire/:slug" element={<DynamicForm />} />
            <Route path="/espace-client" element={<PortalHome />} />
            <Route path="/espace-client/connexion" element={<PortalLogin />} />
            <Route path="/espace-client/activation" element={<PortalActivate />} />
          </Route>

          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="crm" element={<CRM />} />
            <Route path="finance" element={<Finance />} />
            <Route path="factures-clients" element={<ClientInvoices />} />
            <Route path="support" element={<Support />} />
            <Route path="espace-client" element={<ClientAccounts />} />
            <Route path="whatsapp" element={<WhatsAppAdmin />} />
            <Route path="solutions" element={<SolutionsAdmin />} />
            <Route path="services" element={<ServicesAdmin />} />
            <Route path="produits" element={<ProductsAdmin />} />
            <Route path="blog" element={<BlogAdmin />} />
            <Route path="marketing" element={<Marketing />} />
            <Route path="mediatheque" element={<MediaAdmin />} />
            <Route path="pages" element={<PagesAdmin />} />
            <Route path="formulaires" element={<FormsAdmin />} />
            <Route path="utilisateurs" element={<Users />} />
            <Route path="journal" element={<Activity />} />
            <Route path="parametres" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ClientAuthProvider>
    </AuthProvider>
  );
}

export default App;
